import React from 'react';

export default class LoadingIndicator extends React.Component {
    static defaultProps = {
        classNamespace: 'pb-',
        durationError: 1200,
        durationSuccess: 500
    };

    constructor(props) {
        super(props);
        this.state = {
            currentState: this.props.state || 'loading'
        };
    }

    render() {
        var containerClassName = this.props.classNamespace + "container " + this.state.currentState;
        var loadingSVGClassName = this.props.classNamespace + "progress-circle";
        var btnClassName = this.props.classNamespace + "button";
        return (
            <div className={containerClassName}>
                <button className={btnClassName} type={this.props.type} form={this.props.form}>
                    <svg className={loadingSVGClassName} viewBox="0 0 41 41">
                        <path d={"M38,20.5 C38,30.1685093 30.1685093,38 20.5,38"}/>
                    </svg>
                </button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/LoadingIndicator.js